import { Fragment, useLayoutEffect, useMemo, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from './AuthContext';
import { bindSessionWorkspace, createActorDraft } from './workspaceState';

export function SessionWorkspace({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  const queryClient = useQueryClient();
  useLayoutEffect(() => bindSessionWorkspace(session, queryClient), [session, queryClient]);
  return <>{children}</>;
}

export function AuthenticatedWorkspace({ children }: { children: ReactNode }) {
  const { status, user, generation } = useAuth();
  return status === 'authenticated' && !user?.must_change_password ? <Fragment key={generation}>{children}</Fragment> : null;
}

export function useActorDraft(name: string) {
  const { session, generation } = useAuth();
  return useMemo(() => createActorDraft(session, name), [session, generation, name]);
}
